import * as React from 'react';

import { Project } from '../models';

export type ProjectsContextType = { projects: Array<Project> }

export const ProjectsContext = React.createContext<ProjectsContextType>({ projects: [] });